import { useContext } from 'react';
import { CalendarEventContext } from 'contexts/calendar_event_context';

const useCalendarEvent = () => {
    return useContext(CalendarEventContext);
};

export default useCalendarEvent;
